import dayjs from "dayjs";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { GetSubscriptionSetData } from "../../../../../Api/ServiceDatas";
import { useApi } from "../../../../../hooks/useApi";
import { authType } from "../../../../../pages/Login";
import LineBtn from "../../../../Button/LineBtn";
import LineBox from "../../../../DefaultStyles/LineBox";
import Loader from "../../../../DefaultStyles/Loader";
import Table, { TableBody, TableBodyItem } from "../../../../Table/Table";
import { ChatSection, ChatSectionTitle } from "../ChatSearch/ChatSearchResult";
import ChatReportDetailModal from "./OldChatReportDetailModal";
import { IChatReportComplete } from "./OldReportComplete";
import { isNewChat } from "../../../../../pages/Party/ChatInfo";
import { getSubsNameBySubsId3 } from "../../../../../AdminApi/3.0_utils";

export default function OldChatReport() {
  const auth = useRecoilValue(authType);
  const navigate = useNavigate();

  const [reportDetailModal, setReportDetailModal] = useState(false);
  const [detailData, setDetailData] = useState<IChatReportComplete>({
    key: "",
    msgList: [],
    uid: {
      name: "",
      nickname: "",
      uid: "",
    },
    party: {
      partyid: "",
      servsubsid: 0,
    },
    reason: "",
    reasonid: 0,
    target: {
      uid: "",
      name: "",
      nickname: "",
    },
    time: "",
    comptime: "",
    owner: 0,
  });

  const chatReportTableHead = [
    "신고자",
    "PID",
    "Subscription",
    "사유 구분",
    "신고 일시",
    "상세 및 접수",
  ];

  const { response, loading } = useApi({
    method: "get",
    url: auth?.chat ? `oldchat/report?iscomp=0&page=init&size=5` : undefined,
  });

  console.log(response?.data?.list);

  return (
    <ChatSection>
      <ChatSectionTitle>채팅 신고</ChatSectionTitle>

      <LineBox>
        <Table tableHeadData={chatReportTableHead}>
          <>
            {response?.data?.list?.map(
              (d: IChatReportComplete, index: number) => {
                return (
                  <TableBody key={index}>
                    <TableBodyItem
                      clickable={true}
                      onClick={() => navigate(`/users/info/${d?.uid?.uid}`)}
                    >
                      {d?.uid?.uid}_{d?.uid?.name}_{d?.uid?.nickname}
                    </TableBodyItem>
                    <TableBodyItem
                      clickable={true}
                      onClick={() =>
                        navigate(`/party/info/${d?.party?.partyid}`)
                      }
                    >
                      {d?.party?.partyid}
                    </TableBodyItem>
                    <TableBodyItem>
                      {d?.party?.servsubsid}_
                      {getSubsNameBySubsId3(d?.party?.servsubsid)}
                    </TableBodyItem>
                    <TableBodyItem>{d?.reason}</TableBodyItem>
                    <TableBodyItem>
                      {dayjs(d?.time)?.format("YYYY-MM-DD HH:mm")}
                    </TableBodyItem>
                    <TableBodyItem>
                      <LineBtn
                        btnText="상세 내용 및 접수"
                        btnClickEvent={() => {
                          setDetailData(d);
                          setReportDetailModal(true);
                        }}
                        disabled={!auth?.chat}
                      />
                    </TableBodyItem>
                  </TableBody>
                );
              }
            )}

            {reportDetailModal && (
              <ChatReportDetailModal
                closeEvent={() => setReportDetailModal(false)}
                data={detailData}
              />
            )}
          </>
        </Table>
      </LineBox>

      {loading && <Loader />}
    </ChatSection>
  );
}
